import axios from "axios";
import config from "../../../config/config";

const UPLOAD_LINK = config.baseUrl + "owner/contract/upload";
const INSERT_PASSENGER_INFO = config.baseUrl + "owner/contract";
const GET_USER_INFO = config.baseUrl + "owner/contract";
const GET_DRIVER_BY_NCODE = config.baseUrl + "driver/getDriverByNCode"
const GET_CAR_BY_VIN = config.baseUrl + "driver/getDriverByNCode"


export const UploadFiles = (data, token) => {
  return axios.post(UPLOAD_LINK, data, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },
  });
};

export function GetDriverByNCode( params) {
  return axios.post(GET_DRIVER_BY_NCODE,params, {
  });
}

export function GetCarByVin( params) {
  return axios.post(GET_CAR_BY_VIN,params, {
  });
}


export const InsertOwnerInfo = (data, token) => {
  return axios.post(INSERT_PASSENGER_INFO, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
